import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dict'
})
export class DictPipe implements PipeTransform {

  transform(value: string, ...args: any[]): string {
    console.log(value);
    return args[0] ? args[0].map[value.toLowerCase()] : value;
  }

}
